import React, { useEffect } from "react";

import { IonIcon, IonRow, IonCol } from "@ionic/react";
import { useState } from "react";
import "./FileShareMediaList.scss";
import { chevronBackOutline } from "ionicons/icons";
import { utilService } from "../../../../services/utilService";
import { MediaShareInterface } from "./FileShareMediaList.model";
import { FileShareMediaListService } from "./FileShareMediaList.service";
import _ from "lodash";
import Loader from "../../../../components/Shared/Loader/Loader";
import NoResults from "../../../../components/Shared/NoResults/NoResultsComponent";
import { CONSTANTS } from "../../../../constants/callcentral.constants";
import MediaListCard from "../MediaListCard/MediaListCard";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";

interface FileShareMediaListProps {
  selectedUserGuid?: any;
  selectedPatientId?: any;
  selectedUserName?: any;
  isStatusBoard?: any;
  onUploadButtonClicked: () => void;
  isSmallScreen?: boolean;
  isMessageComponent?: boolean;
  smsThreadId?: any;
}
const FileShareMediaList: React.FC<FileShareMediaListProps> = (props) => {
  let history = useHistory();
  const location: any = useLocation();

  const [showLoader, setShowLoader]: any = useState(true);
  const [MediaListData, setMediaListData]: any = useState([]);
  const [MediaListFullData, setMediaFullListData]: any = useState([]);
  const [selectedDoctorDetails, setSelectedDoctorDetails]: any = useState([]);
  const [isSentBtnClicked, setIsSentBtnClicked]: any = useState(false);
  const [isLargeScreen, setIsLargeScreen]: any = useState(true);
  const [columnSize, setColumnSize]: any = useState("12");

  useEffect(() => {
    if (
      !_.isEmpty(location.state) &&
      location.pathname === "/client/file-share/mediaList"
    ) {
      const currentLocation: any = location;
      setSelectedDoctorDetails(currentLocation.state.selectedDoctorDetails);
      setIsSentBtnClicked(currentLocation.state.buttonClickStatus);
      getFileShareListDetails(
        currentLocation.state.selectedDoctorDetails,
        currentLocation.state.buttonClickStatus
      );
    }
  }, [location]);

  useEffect(() => {
    if (props.selectedPatientId || props.selectedUserGuid) {
      //Boolean value should be changed to switch case for future features - show all list , received list or send list
      getNotificationFileShareListDetails(
        props.selectedUserGuid,
        props.isStatusBoard
      );
    }
    checkIfLargeScreen();
    props.isSmallScreen ? setColumnSize("12") : setColumnSize("4");
    if (props.isMessageComponent) {
      setColumnSize("6");
    }
  }, [props.selectedUserGuid]);

  const setFilteredMediaList = (result: any, isSentBtnClicked: boolean) => {
    var filteredList: any = [];
    if (isSentBtnClicked) {
      filteredList = result.filter(
        (item: any) =>
          item.action === 1 || item.action === 3 || item.action === 4
      );
    } else {
      filteredList = result.filter((item: any) => item.action === 2);
    }
    setMediaListData(filteredList);
  };

  const getFileShareListDetails = async (
    selectedCard: any,
    buttonClickStatus: boolean
  ) => {
    // setShowLoader(true);
    const params: any = getFileShareMediaListParams(selectedCard);
    const respFileShareMediaListResult: MediaShareInterface =
      await FileShareMediaListService.getFileShareMediaListDetails(params);
    if (
      respFileShareMediaListResult.isSuccess &&
      respFileShareMediaListResult.result
    ) {
      setMediaFullListData(respFileShareMediaListResult.result);
      setFilteredMediaList(
        respFileShareMediaListResult.result,
        buttonClickStatus
      );
    } else {
      console.log("error");
      FileShareMediaListService.handleErrorResponse();
    }
    setShowLoader(false);
  };

  const getNotificationFileShareListDetails = async (
    selectedGuid: any,
    buttonClickStatus: boolean
  ) => {
    // setShowLoader(true);
    const params: any = getNotificationFileShareMediaListParams(selectedGuid);
    const respFileShareMediaListResult: MediaShareInterface =
      await FileShareMediaListService.getFileShareMediaListDetails(params);
    if (
      respFileShareMediaListResult.isSuccess &&
      respFileShareMediaListResult.result
    ) {
      setMediaFullListData(respFileShareMediaListResult.result);
      setFilteredMediaList(
        respFileShareMediaListResult.result,
        buttonClickStatus
      );
    } else {
      console.log("error");
      FileShareMediaListService.handleErrorResponse();
    }
    setShowLoader(false);
  };

  const getFileShareMediaListParams = (selectedCard: any) => {
    return {
      guid: selectedCard[0].guid,
      reg_code: utilService.getNetwork(),
    };
  };

  const getNotificationFileShareMediaListParams = (selectedGuid: any) => {
    if (props.selectedPatientId) {
      return {
        patient_id: props.selectedPatientId,
        reg_code: utilService.getNetwork(),
      };
    } else {
      return {
        guid: selectedGuid,
        reg_code: utilService.getNetwork(),
      };
    }
  };

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "large") {
      setIsLargeScreen(true);
    } else {
      setIsLargeScreen(false);
    }
  };

  return (
    <div className="file-share-media-list-main-container">
      <div className="file-share-media-list-wrapper">
        <div className="file-share-header">
          {!props.selectedUserGuid && (
            <div className="back-icon" onClick={() => history.goBack()}>
              <IonIcon icon={chevronBackOutline} />
            </div>
          )}
          {!_.isEmpty(selectedDoctorDetails) && (
            <div className="header-name">
              {selectedDoctorDetails[0].firstName}{" "}
              {selectedDoctorDetails[0].lastName}
            </div>
          )}
          {!_.isEmpty(props.selectedUserName) && (
            <div className="header-name">{props.selectedUserName}</div>
          )}

          {!props.selectedUserGuid && (
            <div className="file-share-icon-div">
              <Link
                to={{
                  pathname: "/client/file-share/upload-media",
                  state: {
                    selectedDoctorData: selectedDoctorDetails,
                    mediaAction: CONSTANTS.MEDIA_ACTIONS.SEND,
                  },
                }}
                style={{ textDecoration: "none" }}
              >
                <div className="file-share-icon">
                  <div className="input-icon icon-document"></div>
                </div>
              </Link>
            </div>
          )}
          {props.selectedUserGuid && !props.isStatusBoard && (
            <div className="file-share-icon-div">
              <div
                className="file-share-icon"
                onClick={() => props.onUploadButtonClicked()}
              >
                <div className="input-icon icon-document"></div>
              </div>
            </div>
          )}
        </div>
        <div
          className={`media-list-items-container ${
            props.selectedUserGuid && "media-list-height"
          } ${
            props.selectedUserGuid &&
            isLargeScreen &&
            "media-list-height-large-screen"
          }
      
          `}
        >
          {!showLoader ? (
            <div className="media-list-card-wrapper">
              <IonRow>
                {!_.isEmpty(MediaListData) ? (
                  MediaListData.map((item: any) => {
                    return (
                      <IonCol size-lg={columnSize} size="12">
                        <MediaListCard
                          selectedPatientId={props.selectedPatientId}
                          selectedUserId={props.selectedUserGuid}
                          mediaItem={item}
                          selectedDoctorData={selectedDoctorDetails}
                          smsThreadId={props.smsThreadId}
                          fromFileShare={true}
                          updateMediaList={() =>
                            getNotificationFileShareListDetails(
                              props.selectedUserGuid,
                              props.isStatusBoard
                            )
                          }
                        ></MediaListCard>
                      </IonCol>
                    );
                  })
                ) : (
                  <IonCol size-lg={columnSize} size="12">
                    <NoResults></NoResults>
                  </IonCol>
                )}
              </IonRow>
            </div>
          ) : (
            <div className="loader-div">
              <Loader></Loader>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileShareMediaList;
